import { Injectable } from '@angular/core';

import { Key } from 'ts-key-enum';

export const HIGHLIGHT_CLS = 'highlighted';

@Injectable()
export class SearchSuggestionKeyboardControlService {
  private links: NodeListOf<HTMLElement>;
  private currentSelectedLinkIndex = 0;

  handleKeyboardEvent(event: KeyboardEvent): void {
    switch (event.key) {
      case Key.ArrowDown:
        event.preventDefault();
        this.highlightNextLink();
        break;
      case Key.ArrowUp:
        event.preventDefault();
        this.highlightPreviousLink();
        break;
      case Key.Enter:
        this.selectHighlightedLink();
        break;
      default:
        break;
    }
  }

  updateLinkNodes(linkNodes: NodeListOf<HTMLElement>): void {
    this.links = linkNodes;
    this.currentSelectedLinkIndex = undefined;
    this.disableFocusByTab(this.links);
  }

  selectHighlightedLink(): void {
    if (typeof this.currentSelectedLinkIndex !== 'undefined') {
      this.links[this.currentSelectedLinkIndex].click();
    }
  }

  highlightNextLink(): void {
    this.toggleLinkHighlight(this.links[this.currentSelectedLinkIndex], false);
    if (typeof this.currentSelectedLinkIndex === 'undefined') {
      this.currentSelectedLinkIndex = 0;
    } else {
      this.currentSelectedLinkIndex += 1;
    }
    this.currentSelectedLinkIndex %= this.links.length;
    this.toggleLinkHighlight(this.links[this.currentSelectedLinkIndex], true);
  }

  highlightPreviousLink(): void {
    this.toggleLinkHighlight(this.links[this.currentSelectedLinkIndex], false);
    this.currentSelectedLinkIndex = this.currentSelectedLinkIndex || 0;
    this.currentSelectedLinkIndex += this.links.length - 1;
    this.currentSelectedLinkIndex %= this.links.length;
    this.toggleLinkHighlight(this.links[this.currentSelectedLinkIndex], true);
  }

  toggleLinkHighlight(linkEle: HTMLElement, isHighlighted: boolean): void {
    isHighlighted ? linkEle?.classList.add(HIGHLIGHT_CLS) : linkEle?.classList.remove(HIGHLIGHT_CLS);
  }

  private disableFocusByTab(linkNodes: NodeListOf<HTMLElement>): void {
    linkNodes.forEach(link => {
      link.tabIndex = -1;
    });
  }
}
